import { Column, Filter } from '@nirvana/shared/dtos/types/shared/filters';
import {
  ActionTakenEnum,
  DetectingModules,
  DetectingTechnologies,
  ThreatType,
} from '@nirvana/shared/dtos/types/shared/threats';
import { CommonThreatsNavigationHelper } from './common.threats.navigation.helper';
import { BlockedNetworkAttackTechniquesNavigationFiltersParams } from '../navigation.interfaces';

export class BlockedNetworkAttackTechniquesNavigationHelper {
  public static getDisplayedColumns(): Array<Column> {
    return [
      Column.LAST_DETECTED,
      Column.DETECTING_MODULE,
      Column.DETECTING_TECHNOLOGY,
      Column.ACTION_TAKEN,
      Column.THREAT_TYPE,
    ];
  }

  public static getFiltersForNavigation(params: BlockedNetworkAttackTechniquesNavigationFiltersParams): Array<Filter> {
    const filters = [
      CommonThreatsNavigationHelper.getLastDetectedOnFilterFromTimeRange(params.timeRange),
      CommonThreatsNavigationHelper.getCategoryFilter(),
      BlockedNetworkAttackTechniquesNavigationHelper.getActionsTakenFilter(),
      CommonThreatsNavigationHelper.getDeviceNameFilter(),
      CommonThreatsNavigationHelper.getThreatTypeFilter(params.threatTypes),
      BlockedNetworkAttackTechniquesNavigationHelper.getDetectingTechnologyFilter(),
      BlockedNetworkAttackTechniquesNavigationHelper.getDetectingModuleFilter(),
    ];

    return !params.isPartner ? filters : filters.concat(CommonThreatsNavigationHelper.getCompanyFilter(params.targets));
  }

  private static getActionsTakenFilter(): Filter {
    return {
      actionTaken: {
        in: [ActionTakenEnum.BLOCKED],
      },
    };
  }

  private static getDetectingTechnologyFilter(): Filter {
    return {
      detectingTechnology: {
        in: [DetectingTechnologies.NETWORK_PROTECTION_NETWORK_ATTACK_DEFENSE],
      },
    };
  }

  private static getDetectingModuleFilter(): Filter {
    return {
      detectingModule: {
        in: [DetectingModules.NETWORK_PROTECTION],
      },
    };
  }
}
